import React from "react";
import { Button, Modal, Form, Input, Radio, Select } from "antd";
const FormItem = Form.Item;
const Option = Select.Option;

const CHOICE_VALUE = {
	ADD_NEW: "add_new",
	REPLACE_ALL: "replace_all",
};

const EmployeeImportModeForm = Form.create()(
	(props) => {
		const { visible, onCancel, onOk, form, confirmLoading } = props;
		const { getFieldDecorator, getFieldValue } = form;
		const titleMsg = "You want to import employees?";
		return (
			<Modal
				visible={visible}
				title={titleMsg}
				okText="Import"
				onCancel={onCancel}
				onOk={onOk}
				okType='primary'
				closable={false}
				maskClosable={false}
				confirmLoading={confirmLoading}
			>
				<Form layout="vertical">
					<FormItem label='Please select import mode?'
						onValuesChange={(props, values) => { console.log(props, values); }}>
						{getFieldDecorator("choice", {
							rules: [{ required: true, message: "Please select a mode!" }],
						})
						(
							<Select placeholder="Please select a mode">
								<Option value={CHOICE_VALUE.ADD_NEW}>Add new users</Option>
								<Option value={CHOICE_VALUE.REPLACE_ALL}>Replace all users</Option>
							</Select>
						)
						}
						{getFieldValue("choice") === CHOICE_VALUE.ADD_NEW &&
                  <p>*New users will be added and existing user will be overwritten</p>
						}
						{getFieldValue("choice") === CHOICE_VALUE.REPLACE_ALL &&
                  <p>*All existing users will be deleted and replaced</p>
						}
					</FormItem>
				</Form>
				{/* <span style={{ color: '#f5222d' }}>If you delete, you will not be able to roll back</span> */}
			</Modal>
		);
	}
);

class EmployeeImportModeModal extends React.Component {
  state = {
  	visible: false,
  	confirmLoading: false,
  };
  showModal = () => {
  	this.setState({ visible: true });
  }
  handleCancel = () => {
  	if (!this.state.confirmLoading)
  		this.clearForm();
  }
  handleOk = () => {
  	const form = this.form;
  	form.validateFields((err, values) => {
  		if (err) {
  			return;
  		}
  		this.setState({ confirmLoading: true });
  		const { onSubmitEmployeeImportMode } = this.props;
  		onSubmitEmployeeImportMode(values.choice);
  		this.clearForm();
  	});
  }

  clearForm() {
  	const form = this.form;
  	form.resetFields();
  	this.setState({ visible: false, user: null, confirmLoading: false });
  }

  saveFormRef = (form) => {
  	this.form = form;
  }
  render() {
  	return (
  		<EmployeeImportModeForm
  			ref={this.saveFormRef}
  			visible={this.state.visible}
  			onCancel={this.handleCancel}
  			onOk={this.handleOk}
  			confirmLoading={this.state.confirmLoading}
  		/>
  	);
  }
}

export default EmployeeImportModeModal;


// WEBPACK FOOTER //
// ./src/components/modal/EmployeeImportModeModal.js